import Phaser from 'phaser';
import dimensions from '../dimensions';
import utils from '../utils';
import sounds from '../sounds';
import DialogueBox from '../objects/DialogueBox';
import ScoreWindow from '../objects/ScoreWindow';
import GameState from '../states/Game';

export default class PracticeState extends GameState {
    init() {
        super.init();

        if (this.mode == "beg") {
            this.spawnRate = GameConfig.beg_spawn_rate;
            this.minSpeed = GameConfig.beg_speed;
            this.maxSpeed = GameConfig.beg_speed;
        } else {
            this.spawnRate = GameConfig.adv_spawn_rate;
            this.minSpeed = GameConfig.adv_speed_min;
            this.maxSpeed = GameConfig.adv_speed_max;
        }

        this.script = Script.Practice;
        this.scriptNo = 0;
    }

    startGame() {
        sounds.simMusic.play();

        this.accuracy = 100;
        this.count = 0;
        this.hits = 0;
        this.misses = 0;
        this.fails = 0;
        this.problemLetters = {};

        this.HUD.visible = true;
        this.game.add.tween(this.HUD).from({ y: this.HUD.y - 50 }, 350, "Linear", true);

        this.letterGenerator = this.game.time.events.loop(1000 / this.spawnRate, function () {
            this.count++;

            if (this.count == GameConfig.letter_count) {
                this.game.time.events.remove(this.letterGenerator);
                this.letterGenerator = null;
            }

            let letter = this.game.add.bitmapText(0, 0, "font-letters-" + GameConfig.practice_font_color["Mission" + this.game.currentMission][this.game.currentLevel], utils.random(this.currentSet), 70);
            this.letterGroup.add(letter);

            letter.x -= letter.width / 2 - this.game.rnd.integerInRange(100, dimensions.gameWidth - 100);
            letter.y -= letter.height / 2 + 50;

            this.letters.push(letter);

            let speed = this.game.rnd.integerInRange(this.minSpeed, this.maxSpeed);
            let time = 1000 / speed * 1000;

            this.game.add.tween(letter).to({ y: dimensions.gameHeight + 90 }, time, 'Linear', true, 0).onComplete.add(function (letter) {
                if (this.problemLetters[letter.text]) this.problemLetters[letter.text]++;else this.problemLetters[letter.text] = 1;

                letter.destroy();
                utils.remove(this.letters, letter);

                this.misses++;
                this.missText.text = "Misses: " + this.misses;

                if (this.letterGenerator === null && this.letters.length === 0) this.endGame();
            }.bind(this, letter));
        }.bind(this));
    }

    endGame() {
        this.removeInput();

        let problemLetters = "";

        for (let i = 0; i < 3; i++) {
            let letter = "";
            for (var key in this.problemLetters) {
                if (this.problemLetters.hasOwnProperty(key)) {
                    if (letter === "" || this.problemLetters[letter] < this.problemLetters[key]) letter = key;
                }
            }

            if (letter !== "" && this.problemLetters[letter] !== 0) {
                this.problemLetters[letter] = 0;
                problemLetters += letter + ",";
            }
        }

        problemLetters = problemLetters.substring(0, problemLetters.length - 1);

        this.scoreWindow = new ScoreWindow(this.game, this.game.add.group(), "Practice");
        this.gameGroup.add(this.scoreWindow);

        this.accuracyText.text = "Accuracy: " + this.accuracy + "%";
        this.scoreWindow.showPractice(this.accuracy, problemLetters, this.hits);
    }

    pressKey(input) {
        switch (input.key) {
            case "Shift":
            case "Control":
            case "Tab":
            case "Alt":
            case "CapsLock":
                return;
        }

        let letter = null;
        if (this.currentSet.indexOf(input.key) !== -1) {
            for (let i = 0; i < this.letters.length; i++) {
                if (this.letters[i].text == input.key) {
                    if (letter === null || letter.y < this.letters[i].y) letter = this.letters[i];
                }
            }

            if (letter) {
                sounds.explode.play();

                var emitter = this.game.add.emitter(letter.x + letter.width / 2, letter.y + 2 * letter.height / 3, 100);
                emitter.makeParticles('sheet', ["particle"]);
                emitter.maxParticleScale = 1;
                emitter.minParticleScale = 0.4;
                emitter.setXSpeed(-100, 100);
                emitter.setYSpeed(-100, 100);
                emitter.setAlpha(1, 0, 500);
                emitter.start(true, 500, null, 20);
                this.gameGroup.add(emitter);

                letter.destroy();
                this.letters.splice(this.letters.indexOf(letter), 1);

                this.hits++;
                this.hitText.text = "Hits: " + this.hits;

                if (this.fails === 0) {
                    this.accuracyText.text = "Accuracy: 100%";
                } else {
                    this.accuracy = Math.floor(this.hits * 100 / (this.hits + this.fails));
                    this.accuracyText.text = "Accuracy: " + this.accuracy + "%";
                }

                if (this.letterGenerator === null && this.letters.length === 0) this.endGame();
            } else {
                this.fails++;
                if (this.fails === 0) {
                    this.accuracyText.text = "Accuracy: 100%";
                } else {
                    this.accuracy = Math.floor(this.hits * 100 / (this.hits + this.fails));
                    this.accuracyText.text = "Accuracy: " + this.accuracy + "%";
                }
            }
        } else {
            this.fails++;
            if (this.fails === 0) {
                this.accuracyText.text = "Accuracy: 100%";
            } else {
                this.accuracy = Math.floor(this.hits * 100 / (this.hits + this.fails));
                this.accuracyText.text = "Accuracy: " + this.accuracy + "%";
            }
        }
    }

    update() {}

    createEnvironment() {
        this.letterGroup = this.game.add.group();
        this.gameGroup.add(this.letterGroup);

        this.letters = [];

        this.createHUD();
    }

    createHUD() {
        this.HUD = this.game.add.group();
        this.gameGroup.add(this.HUD);

        this.HUD.x = dimensions.gameWidth / 2;

        let background = this.game.add.graphics(0, 0);
        background.beginFill(0x000000, 1);
        background.drawRect(-dimensions.actualWidth / 2, 0, dimensions.actualWidth, 50);
        background.alpha = 0.9;
        background.endFill();

        this.hitText = this.game.add.bitmapText(-dimensions.gameWidth / 2 + 10, 32, "font-ui", "Hits: 0", 30);
        this.missText = this.game.add.bitmapText(dimensions.gameWidth / 2 - 10, 32, "font-ui", "Misses: 0", 30);
        this.accuracyText = this.game.add.bitmapText(0, 32, "font-ui", "Accuracy: 100%", 30);

        this.hitText.anchor.set(0, 0.5);
        this.missText.anchor.set(1, 0.5);
        this.accuracyText.anchor.set(0.5);

        this.HUD.add(background);
        this.HUD.add(this.hitText);
        this.HUD.add(this.missText);
        this.HUD.add(this.accuracyText);

        this.HUD.visible = false;
    }
}


//////////////////
// WEBPACK FOOTER
// ./src/states/Practice.js
// module id = 149
// module chunks = 0